const PAUSE_BEFORE_ASKING_AGAIN_MS = 1500;

const wait = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); });

/**
 * Ask the seller's browser, through the extension, for something — and ask once more after a short
 * pause when the first try brings nothing usable. A single request in the browser can fail for a
 * moment; a second failure is reported to the seller rather than tried again and again.
 *
 * @param {function(): Promise<*>} ask - one request to the browser
 * @param {function(*): boolean} isUsable - whether an answer can be used
 * @param {function(number): Promise<void>} [pause]
 * @returns {Promise<*|null>} the first usable answer, or null when neither try brought one
 */
export async function askBrowserTwice (ask, isUsable, pause = wait) {
  const first = await ask().catch(() => null);
  if (isUsable(first)) return first;

  await pause(PAUSE_BEFORE_ASKING_AGAIN_MS);
  const second = await ask().catch(() => null);
  return isUsable(second) ? second : null;
}
